<script>
	import Navigation from './Navigation.svelte';
</script>
<header class="w-100 bg-black white flex flex-column tc justify-center f4 bb--nearblack">
	<h1 class='ma0 f3'>Storylines</h1>
	<Navigation/>
</header>
<style>
		@import url('https://fonts.googleapis.com/css2?family=VT323&display=swap');
		* {
			font-family: "VT323", monospace;
		}
</style>
